import { supabase } from './supabase';

export interface OnboardingProfileInput {
  businessName?: string | null;
  contactName?: string | null;
  phone?: string | null;
  address?: string | null;
  onboardingStep?: number | null;
}

export async function saveOwnOnboardingProfile(
  profile: OnboardingProfileInput = {}
): Promise<void> {
  const { data, error } = await supabase.rpc('save_own_onboarding_profile', {
    p_business_name: profile.businessName ?? null,
    p_contact_name: profile.contactName ?? null,
    p_phone: profile.phone ?? null,
    p_address: profile.address ?? null,
    p_onboarding_step: profile.onboardingStep ?? null,
  });

  if (error) throw error;
  if (data !== true) throw new Error('The onboarding profile was not saved');
}
